import { useRef } from "react";
import Link, { LinkProps } from "next/link";

import { InformationalModal } from "@/components/botanic/Modal";
import { FilterButton } from "@/components/FilteredGrid/FilterButton";

import { useMobileFilterModalContext } from "./MobileFilterModalContext";

export const FULFILLMENT_METHODS = [
  { name: "Direct Shipping", value: "shipping" },
  { name: "Pickup", value: "pickup" },
  { name: "Delivery", value: "delivery" },
];

const MobileFilterModalUI = ({
  chipsUI,
  filtersUI,
  numberOfFiltersSelected,
  clearAllHref,
  setOpenFilterSection,
}: {
  chipsUI: React.ReactNode;
  filtersUI: React.ReactNode;
  numberOfFiltersSelected: number;
  clearAllHref: LinkProps["href"];
  setOpenFilterSection: (filterName?: string) => void;
}) => {
  const { modalActive, setModalActive } = useMobileFilterModalContext();
  const modalButtonRef = useRef(null);

  const clearOpenSection = () => {
    setOpenFilterSection(undefined);
  };

  return (
    <div className="block relative md:hidden">
      <div className="flex items-center overflow-x-auto overflow-y-hidden whitespace-nowrap pb-sm mb-xs gap-xs no-scrollbar fade-white-right">
        <FilterButton
          filterCount={numberOfFiltersSelected}
          onClick={() => {
            setModalActive(true);
          }}
          ref={modalButtonRef}
        />

        {chipsUI}
      </div>
      {modalActive && (
        <InformationalModal
          title={`Filters${
            numberOfFiltersSelected ? ` (${numberOfFiltersSelected})` : ""
          }`}
          returnFocusRef={modalButtonRef}
          onDismissed={() => {
            setModalActive(false);
            clearOpenSection();
          }}
          expository
        >
          <div className="relative -mx-lg h-[calc(100%+32px)] -mt-lg flex flex-col justify-between">
            <div>{filtersUI}</div>
            <div className="sticky -bottom-4 flex w-full p-lg bg-white border-t border-light-grey">
              <Link
                href={clearAllHref}
                className="button button--text flex-shrink-0 px-xxl text-xs text-default leading-[34px]"
              >
                clear all
              </Link>
              <button
                className="button button--secondary"
                onClick={() => {
                  setModalActive(false);
                  clearOpenSection();
                }}
              >
                confirm
              </button>
            </div>
          </div>
        </InformationalModal>
      )}
    </div>
  );
};

export default MobileFilterModalUI;
